import SettingsTabs from "../components/SettingsTabs";
import CompanyInfoTab from "../components/CompanyInfoTab";
import OfficeLocationsTab from "../components/OfficeLocationsTab";
import ReminderSettingsTab from "../components/ReminderSettingsTab";
import NotificationTab from "../components/NotificationTab";
import WorkflowTab from "../components/WorkflowTab";
import BillingTab from "../components/BillingTab";
import TermsAndConditionsTab from "../components/TermsAndConditionsTab";
import LicenseTab from "../components/LicenseTab";
import RoomRequirementTab from "../components/RoomRequirementTab";
import TermInfoTab from "../components/TermInfoTab";
import InstallationMembersTab from "../components/InstallationMembersTab";
import OwnerSecurityScreen from "../../owner_security/screens/OwnerSecurityScreen";
import { useSettingsTabs } from "../hooks/useSettingsTabs";
import { useCompanyInfo } from "../hooks/useCompanyInfo";
import { useAuthStore } from "../../../store/authStore";

/**
 * SettingsScreen - Refactored by USER, updated to include License Info.
 */
export default function SettingsScreen() {
    const { activeTab, setActiveTab } = useSettingsTabs();
    const { company, setCompany, saveCompanyInfo, isSaving, setCompanyLogo, setLogoFile, uploadLogoOnly, setSignatureFile, uploadSignatureOnly } = useCompanyInfo();
    const user = useAuthStore((state) => state.user);
    const userRole = user?.role;

    // Tabs that use the "Flat" design pattern (no card background/border)
    const isFlatTab = ['terms', 'billing', 'license'].includes(activeTab);

    return (
        <div className="space-y-5 animate-in fade-in duration-700">
            <div className={`${isFlatTab ? '' : 'card shadow-sm'} overflow-hidden`}>
                <div className={`${isFlatTab ? '' : 'bg-white border-b border-slate-100'}`}>
                    {/* Note: User uses 'onChange' for setActiveTab in their recent edit */}
                    <SettingsTabs activeTab={activeTab} onChange={setActiveTab} />
                </div>
                <div className={`${isFlatTab ? 'py-4' : 'p-6'}`}>
                    {activeTab === "company" && (
                        <CompanyInfoTab
                            company={company}
                            setCompany={setCompany}
                            onLogoChange={setCompanyLogo}
                            setLogoFile={setLogoFile}
                            uploadLogoOnly={uploadLogoOnly}
                            setSignatureFile={setSignatureFile}
                            uploadSignatureOnly={uploadSignatureOnly}
                            onSave={saveCompanyInfo}
                            isSaving={isSaving}
                        />
                    )}
                    {activeTab === "locations" && <OfficeLocationsTab />}
                    {activeTab === "reminders" && <ReminderSettingsTab />}
                    {/* {activeTab === "notifications" && <NotificationTab />} */}
                    {activeTab === "workflow" && <WorkflowTab />} 
                    {activeTab === "billing" && <BillingTab />}
                    {activeTab === "terms" && <TermsAndConditionsTab />}
                    {activeTab === "license" && userRole === 'owner' && <LicenseTab />}
                    {activeTab === "ownerSecurity" && userRole === 'owner' && <OwnerSecurityScreen />}
                    {activeTab === "rooms" && <RoomRequirementTab />}
                    {activeTab === "termsInfo" && <TermInfoTab />}
                    {activeTab === "installationMembers" && <InstallationMembersTab />}
                </div>
            </div>
        </div>
    );
}
